/**
 * 接口api 配置
 */
import axios from 'axios';
import { find } from 'lodash'
export const WWW = ``;
export const userUrl = ``;
export const URI = `http://gateway.lianlianche.com:9000`; //生产
// export const URI = `http://lianlianche.qicp.vip:9000`; //测试
// export const URI = `http://lianlianche.qicp.vip:9001`; //预生产
export const uid = ` ` || `1fb004b2cbe54c0b92bcab3cb58ad9c3`;
export const config = {
    EDV: '',
    TEST: '',
    PRO: ''
}

import { stringify, parse } from 'qs';
import { Toast } from 'mint-ui';
import { setCookie, setToken } from '@/utils/auth'


export const clearToken = () => {
    /**
     * 清除本地登录信息
     */
    window.localStorage.removeItem('uid')
    window.localStorage.removeItem('token')
}

export const getUnionId = () => {
    return window.localStorage.getItem('unionId')
}
export const getInvitationCode = () => {
    let invitationCode = window.localStorage.getItem('invitationCode');
    if (invitationCode && invitationCode != 'undefined' && invitationCode != 'null' && invitationCode != '') {
        return invitationCode
    }
}
export const getUid = () => {
    let uid = window.localStorage.getItem('uid')
    if (uid && uid != 'undefined' && uid != 'null' && uid != '404') {
        return uid
    }
}
export const getToken = () => {
    let token = window.localStorage.getItem('token');
    if (token && token != 'undefined' && token != 'null' && token != '404') {
        return token
    }
}

axios.defaults.timeout = 20000; // 多少秒请求超时
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['X-token'] = '20000:d2f6f438fe3dfffac831892c2ca54ddb60d52ff2952013b8:4126dd28fa04e00f02dfe74bf90518f6c5782769c678941c';
// axios.defaults.headers.post['X-uid'] = '3';

/**
 * axios  拦截器 提示
 */
axios.interceptors.response.use(data => {
    if (data.status && data.status == 200) {
        return data.data;
    } else {
        Toast('服务器未知错误!');
        return {};
    }
}, err => {
    if (err.response) {
        if (err.response.status == 404) {
            Toast('服务器被吃了⊙﹏⊙∥');
        } else if (err.response.status == 401) {
            Toast('权限不足,请联系管理员!');
        } else if (err.response.status >= 500 && err.response.status < 600) {
            Toast('服务器未知错误!');
        }
    } else {
        Toast(err);
    }
    return Promise.resolve(err);
})


export const API_GET = (url, params = {}, isFullUrl = false) => {
    let _url = URI + url;
    if (isFullUrl) {
        // 是否是完整路径
        _url = url
    }
    return axios.get(_url, {
        params: params,
    })
}

export const API_POST = (url, body = {}, isFullUrl = false) => {
    let _url = URI + url;
    if (isFullUrl) {
        _url = url
    }
    return axios.post(_url, stringify(body))
}

export const API_POST_JSON = (url, body = {}) => {
    let _url = URI + url;
    return axios.post(_url, JSON.stringify(body), { headers: { 'Content-Type': 'application/json;charset=utf-8' } })
}

/**
 * 需要带请求头的接口
 * @param {*} url
 * @param {*} body
 * @param {*} isFullUrl
 * @param {*} requestHeaders
 */
export const API_GET_TOKEN = (url, body = {}, isFullUrl = false, requestHeaders = {}) => {
    let _url = URI + url;
    if (isFullUrl) {
        _url = url
    }
    return axios.get(_url, stringify(body), {
        headers: GET_HEADERS()
    })
}

export const GET_HEADERS = () => {
    return {
        'Authorization': '1212',
        'X-uid': getUid(),
        'X-did': 'did',
        'X-token': getToken(),
    }
}


/**
 * 保存数据字典本地
 *
 *  */
export const SET_DICT = () => {
    API_GET_TOKEN("/lianlianche-car/carEnumDictionary/list", {}).then(res => {
        if (res.status == 0) {
            window.localStorage.setItem('dict', JSON.stringify(res))
        }
    });
}

/**
 * 获取数据字典
 *
 *  */
export const GET_DICT = (typeId, classId) => {
    // typeId
    // 1 新手二手车
    // 2 车辆状态
    // 3 车辆颜色
    // 4 内饰颜色
    // 5 排气标准
    // 6 车辆类型 (suv,跑车。。。。）
    // 7 进气方式
    // 8 烧油类型
    // 9 换档方式
    // 10 前后驱四驱等
    // 11 公私车
    // 12 是否运营
    // 13 是否交税·····
    // 14 网络寄售、实车寄售、收购等

    let _dict = window.localStorage.getItem('dict')
    if (_dict && _dict != undefined) {
        const dic = JSON.parse(_dict).data
        var arr = dic.find(v => v.typeId === typeId)
        if (arr) {
            var obj = arr.dictionaryList.find(d => d.classId == classId)
            if (obj) {
                return obj.className
            } else {
                return ""
            }
        } else {
            return ""
        }
    }
    return {}
}

/**
 * js 刷新时候，先走一遍数据字典，保存到本地
 *  */
SET_DICT()


/**
 * 是否是微信浏览器
 */
export const IS_WEIXIN = () => {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
        $("#rs").text("微信浏览器");
    } else {
        return false;
        $("#rs").text("不是微信浏览器");
    }
}

/**
 * 
 */


/**
 * 获取本地经纬度
 *  */
export const getLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
        Toast("浏览器不支持地理定位。");
    }
}

function showPosition(position) {
    console.log(position);
    var lat = position.coords.latitude;  //纬度 
    var lag = position.coords.longitude;  //经度 

}

function showError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            Toast("定位失败,用户拒绝请求地理定位");
            break;
        case error.POSITION_UNAVAILABLE:
            Toast("定位失败,位置信息是不可用");
            break;
        case error.TIMEOUT:
            Toast("定位失败,请求获取用户位置超时");
            break;
        case error.UNKNOWN_ERROR:
            Toast("定位失败,定位系统失效");
            break;
    }
}

// export const GET_HEADERS = () => {
//     return {
//         'X-uid': getUid(),
//         'X-did': 'did',
//         'X-token': getToken()
//     }
// }


// 执行初始化
init()

function init() {
    /**
     * 页面初始化，获取app，url传递过来的参数
     */
    let url = window.location.hash;
    if (url.indexOf('?') > -1) {
        let strArr = url.split('?')
        let auth = parse(strArr[1])
        console.log(auth)
        if (auth.uid) {
            window.localStorage.setItem('uid', auth.uid)
            window.localStorage.setItem('token', auth.token)
            window.localStorage.setItem('storeId', auth.storeId)
            setCookie("token", auth.token);
            setCookie("uid", auth.uid);
            setCookie("storeId", auth.storeId);
        }
    }

}


// WEBPACK FOOTER //
// ./src/apiConfig.js